<!-- Invoice and payments -->

<ion-row class="itinerary-row" id="InvoiceSection" *ngIf="!doesInvoiceExists">
  <ion-col>
    <h6>Payments</h6>
    <ion-row size="12">
      <div class="w-100" *ngIf="allPaymentsOfLead">
        <app-grid-view 
          [allData]="allPaymentsOfLead" 
          [columns]="allPaymentsOfLeadColumns" 
          [showColumnSelector]="false" 
          [optionsValues]="false"
        ></app-grid-view>
      </div>
    </ion-row>
    <ion-row>
      <ion-button class="unfilled-blue-btn" (click)="addPaymentToLead()">
        Add Payment
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="refundPaymentToLead()">
        Refund Payment
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="addInvoiceForClinet()">
        Add Invoice
      </ion-button>
    </ion-row>
  </ion-col>
</ion-row>

<ion-row class="itinerary-row" id="InvoiceSection" *ngIf="doesInvoiceExists">
  <ion-col>
    <h6>Invoice</h6>
    <ion-row size="12">
      <div class="w-100" *ngIf="clientInvoice">
        <app-grid-view 
          [allData]="clientInvoice" 
          [columns]="clientInvoiceColumns" 
          [showColumnSelector]="false"
          [optionsValues]="invoiceOptionsValues" 
          (triggerDeleteRow)="deleteInvoiceRow($event)"
          (triggerEditRow)="editInvoiceOpen($event)" 
          (triggerViewRow)="viewInvoice($event)"
          (triggerAddPaymentRow)="addPaymentForInvoice($event)"
        ></app-grid-view>
      </div>
    </ion-row>
    <ion-row>
      <ion-button class="unfilled-blue-btn" (click)="addInvoiceForClinet()">
        Add Invoice
      </ion-button>
    </ion-row>
  </ion-col>
</ion-row>